// extracted by mini-css-extract-plugin
module.exports = {"text":"B18_text__2V9yC"};